import { z } from 'zod'

export const integrationToken = z.object({
    id: z.string(),
    name: z.string(),
    lastUsedAt: z.coerce.date().nullable(),
    expiresAt: z.coerce.date().nullable(),
    isExpired: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
})

export const integrationTokenWithPlainText = z.object({
    token: integrationToken,
    plainTextToken: z.string(),
})

export type IntegrationToken = z.infer<typeof integrationToken>
export type IntegrationTokenWithPlainText = z.infer<typeof integrationTokenWithPlainText>
